<template>
  <div class="xcard">
    <h3 class="text-center">Menu de Reporte Titulaciones</h3>
    <hr />


    <v-row>
      <v-col
        v-if="ispermitido"
        cols="12"
        sm="4"
        lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="reporteOpen('reportestitulacionesprograma')">
            <v-img
              src="https://direccionempresarial.com.mx/wp-content/uploads/2021/03/plataforma_de_cobranza.png"
              height="150px"></v-img>

            <v-card-title> Estado Titulacion por programa </v-card-title>

            <v-card-subtitle> Estado de titulacion de los programas por cada alumno. </v-card-subtitle>
          </v-card>
        </template>
      </v-col>

      <v-col
        v-if="ispermitido"
        cols="12"
        sm="4"
        lg="3">
        <template>
          <v-card class="mx-auto" max-width="284" @click="reporteOpen('reportestitulacionessede')">
            <v-img
              src="https://media.istockphoto.com/id/1202048771/es/vector/el-personaje-del-hombre-de-negocios-exitoso-se-encuentra-en-una-postura-segura-en-enorme.jpg?s=612x612&w=0&k=20&c=KKJV2TKw4yZkpQAFdlymTZnw0bj7yHpJjaLIgWghodI="
              height="150px"></v-img>

            <v-card-title> Estado Titulacion de Sede </v-card-title>

            <v-card-subtitle> Estado Titulacioin de los programas de una sede de cada gestion. </v-card-subtitle>
          </v-card>
        </template>
      </v-col>


    </v-row>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        estudiantes: [],
        ispermitido: false,
      };
    },
    watch: {},
    components: {},
    methods: {
      reporteOpen(url) {
        this.$router.push({ name: url });
      },
      openlink(url) {
        window.location.href = url;
      },
    },
    mounted() {
      this.ispermitido =
      this.$store.state.CARGO.id == 6 ||
                  this.$store.state.CARGO.id == 5 ||
                  this.$store.state.CARGO.id == 17 ||
                  this.$store.state.CARGO.id == 1 ||
                  this.$store.state.CARGO.id == 22
    },
  };
</script>
